module.exports = __webpack_public_path__ + "static/media/rocket-loading.42895599.svg";